import { Injectable } from "@angular/core";
import { environment } from "../../environments/environment";
import { Http, Headers, Response } from "@angular/http";
import { Observable } from "rxjs/Observable";
import { LoginResponse } from "@models/auth";

@Injectable()
export class LoginService {
    private headers = new Headers({ "Content-Type": "application/x-www-form-urlencoded", "Accept": "application/json;charset=UTF-8" });
    constructor(private http: Http) { }
    getToken(username: string, password: string): Observable<LoginResponse> {
        let auth: any = "username=" + username + "&password=" + password + "&grant_type=password";
        return this.http.post(environment.apiUrl + "Token", auth, { headers: this.headers })
            .map((response: Response) => {
                let json = response.json();

                // manually mapping so that we dont have to deal with underscores and periods in properties
                let model: LoginResponse = {
                    username: <string>json.username,
                    token: <string>json.access_token,
                    type: <string>json.token_type,
                    expiresIn: <number>json.expires_in,
                    expires: new Date(json[".expires"]),
                    issued: new Date(json[".issued"])
                };

                return model;
            })
            .catch((error: Response) => {
                console.error(error);
                if (error.status === 400) {
                    return Observable.throw("Incorrect Username or Password please try again.");
                } else {
                    return Observable.throw(error.json().error || "Server Error");
                }
            });
    }
}



// WEBPACK FOOTER //
// C:/WORK/Projects/ActNow_NG2/src/app/login/login.service.ts